<div class="duration-radios">
    <ng-container *ngFor="let radio of fields.radios">
        <div class="duration-radio">
            <input type="radio" [id]="radio.id" [name]="fields.server" [checked]="radio.checked" (change)="checkRadio(fields, radio)">
            <label [for]="radio.id">{{radio.id}} quote</label>
          </div>
    </ng-container>
</div>